<div class="content__wrapper" id="devicesDiv">
    <!-- Navtabs -->
    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a *ngIf="showHideNavBar" class="nav-link" data-toggle="tab" (click)="setIndex(0)" [ngClass]="{'active': tabIndex === 0}">
                <span i18n="@@devices.nav-tab.devices">DEVICES</span></a>
        </li>
        <li class="nav-item" *ngIf="loginUserRole !== 'srtUser'">
            <a *ngIf="showHideNavBar" class="nav-link" data-toggle="tab" (click)="setIndex(1)" [ngClass]="{'active': tabIndex === 1}">
                <span i18n="@@devices.nav-tab.active-device-report">ACTIVE DEVICE REPORT</span></a>
        </li>
        <li class="nav-item" *ngIf="loginUserRole !== 'srtUser'">
            <a *ngIf="showHideNavBar && !deviceExecutiveRole" class="nav-link" data-toggle="tab" (click)="setIndex(2)" [ngClass]="{'active': tabIndex === 2}">
                <span i18n="@@devices.nav-tab.store-logo">STORE LOGO</span></a>
        </li>
        <li *ngIf="loginUserRole !== 'srtUser'" class="nav-item">
            <a *ngIf="showHideNavBar && !deviceExecutiveRole" class="nav-link" data-toggle="tab" (click)="setIndex(3)" [ngClass]="{'active': tabIndex === 3}">
                <span i18n="@@devices.nav-tab.device-settings">DEVICE SETTINGS</span></a>
        </li>
    </ul>
    <div class="tab-content" id="tabContent">
        <div id="tabIndex0" *ngIf="tabIndex === 0" class="tab-pane" [ngClass]="{'active': tabIndex === 0}">
            <iposcen-device-dashboard></iposcen-device-dashboard>
        </div>
        <div id="tabIndex1" *ngIf="tabIndex === 1" class="tab-pane" [ngClass]="{'active': tabIndex === 1}">
            <iposcen-active-device-report></iposcen-active-device-report>
        </div>
        <div id="tabIndex2" *ngIf="tabIndex === 2" class="tab-pane" [ngClass]="{'active': tabIndex === 2}">
            <iposcen-store-logo></iposcen-store-logo>
        </div>
        <div id="tabIndex3" *ngIf="tabIndex === 3" class="tab-pane" [ngClass]="{'active': tabIndex === 3}">            
            <iposcen-device-settings></iposcen-device-settings>
        </div>        
    </div>
    <iposcen-spinner-overlay *ngIf="showRetailGif" [isCard]="true"></iposcen-spinner-overlay>
    <iposcen-spinner-overlay *ngIf="!showRetailGif" [isCard]="false"></iposcen-spinner-overlay>
</div>
